import { CSSProperties } from "react";
import { ITheme } from "../../utils/theme";

export const tableSubCellStyle = () => ({
  fontWeight: 'bold',
  fontSize: '11px',
  color: 'black',
  padding: 0,
  borderBottom: 'none',
});

export const iconStyle: CSSProperties = {
  display: 'inline-block',
  textAlign: 'right',
  paddingRight: '16px'
}

export const noDataContainerStyle = {
  display: 'flex',
  minHeight: '200px',
  justifyContent: 'center',
  alignItems: 'center',
}

export const notConfirmedIconStyle = (theme: ITheme) => ({
  fill: theme.palette.red[500],
  marginRight: 1,
  display: 'block',
  width: '40px',
  height: '40px',
  float: 'left',
})

export const checkIconStyle = (theme: ITheme) => ({
  fill: theme.palette.success.light,
  marginRight: 1,
  display: 'block',
  width: '40px',
  height: '40px',
  float: 'left',
})

export const iconWrapperStyle = {
  display: 'flex',
  alignItems: 'center',
}

export const notesWrapperStyle = (theme: ITheme) => ({
  background: theme.palette.warning.light,
  borderRadius: 1,
  padding: 1,
  margin: 1,
  marginBottom: 4,
  '& .MuiTypography-root': {
    fontSize: '0.8rem',
  },
  '& .MuiTypography-root.bold': {
    fontWeight: 'bold',
  },
  '& .MuiTypography-root.italic': {
    fontStyle: 'italic',
    textDecoration: 'underline'
  }
});

export const haveConfirmedSubtitleStyle = {
  color: 'success.light',
  marginTop: 1,
  marginBottom: 1
}

export const viewReceiptStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-end',
  color: 'black',
  textDecoration: 'none'
}

export const viewReceiptIconStyle = {
  marginRight: '36px',
  marginBottom: '8px',
  display: 'inline-block',
  background: 'white',
  '& path': {
    fill: 'black'
  }
}

export const disclaimerContainerStyle = {
  position: "relative",
  width: "100%",
  margin: "auto"
}

export const disclaimerContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: "-48px",
  width: "100%"
}

export const disclaimerStyle = {
  display: "flex",
  color: (theme: ITheme) => theme.palette.red[650],
  cursor: "pointer",
  mb: 1,
  "& p": {
    fontWeight: "bold",
  }
}